module.exports = __webpack_public_path__ + "static/img/QRcode.e15f88a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/QRcode.jpg
// module id = PpJZ
// module chunks = 2